module.exports = __webpack_public_path__ + "images/264632cea0f48018afed1a81a62e105c4.svg";